<script>
/**
 * 递归菜单组件（函数式，返回片段以保证 el-menu 直接子节点）
 */
export default {
  name: 'MenuTree',
  functional: true,
  props: {
    menus: {
      type: Array,
      default: () => []
    }
  },
  render(h, ctx) {
    const menus = ctx.props.menus || []
    const nodes = []
    menus.forEach(item => {
      // 按钮类型(menuType=3)不渲染为侧边栏菜单项
      if (item.menuType === 3) return
      const icon = item.icon ? h('i', { class: item.icon }) : null
      if (item.menuType === 1) {
        // 子菜单：icon 与文字均带 slot="title" 作为 el-submenu 的平级 children
        // （等价于 <template slot="title"><i/><span/></template> 编译产物）。
        // Element UI 收起时，title slot 的文字 span 被隐藏，只显示图标。
        const subChildren = []
        if (icon) subChildren.push(h('i', { class: item.icon, slot: 'title' }))
        if (item.menuName) subChildren.push(h('span', { slot: 'title' }, item.menuName))
        if (item.children && item.children.length) {
          subChildren.push(h('menu-tree', { props: { menus: item.children } }))
        }
        nodes.push(h('el-submenu', {
          key: item.id,
          props: { index: item.path || ('m' + item.id) }
        }, subChildren))
      } else {
        // 叶子菜单：图标放默认 slot（收起后仍保留显示），文字放 title slot（收起后隐藏）
        const content = []
        if (icon) content.push(icon)
        if (item.menuName) {
          content.push(h('span', { slot: 'title' }, item.menuName))
        }
        nodes.push(h('el-menu-item', {
          key: item.id,
          props: { index: item.path }
        }, content))
      }
    })
    return nodes
  }
}
</script>
